export const MenuIcon: React.FC = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23 17.8336H1V15.5003H23V17.8336ZM23 13.167H1V10.8337H23V13.167ZM23 8.50033H1V6.16699H23V8.50033Z" fill="#FAFAFA" />
        </svg>
    );
};
